// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1-Obd","right":"styles_right__35m5-"};